<template>
  <div class="app-background">
    <div class="cxgl" @click="openCXGL"></div>
    <div class="zmba" @click="goTo('https://www.zlcp.org.cn/')"></div>
    <div class="zmcp" @click="goTo('https://cnzlpp.com/website/home')"></div>
    <Header></Header>
    <div class="banner"></div>
    <div class="main-container">
      <div class="homeModule">
        <span class="operatebook" @click="operateDownload" v-if="isLogin"></span>
        <div
          class="homeModuleItem homeTop"
          v-for="(item, index) in homeModuleList"
          :key="'homeModuleList_' + index"
        >
          <div class="mit">
            <div class="mit-t">{{ item.title }}</div>
            <div class="mit-c">
              <div
                class="mit-cl"
                style="cursor: pointer"
                @click="
                  goTo(
                    `/jzz/stand/standList?standardLevel=${item.title}&type=入库标准`
                  )
                "
              >入库标准</div>
              <div
                class="mit-cr"
                style="cursor: pointer"
                v-if="item.text"
                @click="goToApply(index, item)"
              >{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="large-box">
        <div class="large-title">新闻政策</div>
        <!-- <div class="large-more" @click="$router.push({path:'/news/list'})">
          更多
          <i class="img"></i>
        </div>-->
      </div>
      <div class="midbtn">
        <div
          :class="newsBtnIndex == index ? 'active' : ''"
          v-for="(item, index) in newsBtnList"
          :key="'newsBtnList_' + index"
          @click="changenewsBtnIndex(index)"
        >{{ item.title }}</div>
      </div>
      <div class="pageList">
        <div
          class="pageItem pageItem2"
          v-for="(item, index) in newsList"
          :key="'newsList_' + index"
        >
          <img src="../assets/7.png" />
          <div class="pageItemTitle" style="width: 620px">
            <div
              class="name point"
              style="width: 620px"
              @click="
                $router.push({ path: '/news/detail', query: { id: item.id } })
              "
            >{{ item.title }}</div>
          </div>
          <span
            style="width: 170px; padding-right: 10px; box-sizing: border-box"
            class="line_1"
            :title="item.areaName"
          >{{ item.areaName }}</span>
          <span>{{ item.pubTime }}</span>
          <div class="pageItemBtnBox">
            <div
              class="pageItemBtn"
              @click="
                $router.push({ path: '/news/detail', query: { id: item.id } })
              "
            >
              <i class="el-icon-view" style="color: #fff; margin-right: 3px"></i>
              <div style="color: #fff">详情</div>
            </div>
          </div>
        </div>
        <EmptyList v-if="newsList.length == 0"></EmptyList>
      </div>
      <pagination
        v-show="total2 > 0"
        :total="total2"
        :page.sync="queryParams2.pageNum"
        :limit.sync="queryParams2.pageSize"
        @pagination="getList"
      />
      <div class="large-box">
        <div class="large-title">“金种子”企业入库清单</div>
      </div>
      <el-card class="mb30">
        <el-form :model="queryParams" :rules="rules" ref="queryParams" label-width="100px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="企业名称" prop="companyName">
                <el-input v-model="queryParams.companyName" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="tac">
          <el-button type="primary" @click="getHomeList">查询</el-button>
          <el-button @click="clearForm">重置</el-button>
        </div>
      </el-card>
      <div class="midbtn">
        <div
          :class="homeBtnIndex == index ? 'active' : ''"
          v-for="(item, index) in homeBtnList"
          :key="'homeBtnList_' + index"
          @click="changehomeBtnIndex(index)"
        >{{ item.title }}</div>
      </div>
      <div class="pageList">
        <div
          class="mb10 emptys"
          v-if="pageList.length > 0"
        >温馨提示：当前页面只显示最新的20条数据，如未在列表显示，请输入企业名称进行查询！</div>
        <div class="pageItem" v-for="(item, index) in pageList" :key="'pageList_' + index">
          <img src="../assets/7.png" />
          <div class="pageItemTitle">
            <div class="name point" @click="companyinfoHandle(item)">{{ item.companyName }}</div>
            <i class="settle" v-if="item.countryStatus"></i>
          </div>
          <span>
            {{
            (item.backTime ? item.backTime : item.storageTime)
            ? (item.backTime ? item.backTime : item.storageTime).split(" ")[0]
            : ""
            }}
          </span>
          <div class="pageItemBtnBox">
            <div class="pageItemBtn" @click="companyinfoHandle(item)" style="margin-right: 10px">
              <i class="el-icon-view" style="color: #fff; margin-right: 3px"></i>
              <div style="color: #fff">详情</div>
            </div>
            <!-- <div class="pageItemBtn" @click="scoreHandle(item)" style="margin-right:10px">
              <i class="el-icon-view" style="color: #fff;margin-right: 3px;"></i>
              <div style="color: #fff;">评价</div>
            </div>-->
            <div
              class="pageItemBtn"
              style="margin-right: 10px"
              @click="toFeedBack(item.id, item.objectionId)"
            >
              <i
                :class="
                  isLogin && item.objectionId
                    ? 'el-icon-view'
                    : 'el-icon-warning-outline'
                "
                style="color: #fff; margin-right: 3px"
              ></i>
              <div style="color: #fff" v-if="isLogin && item.objectionId">查看异议</div>
              <div style="color: #fff" v-else>异议</div>
            </div>
            <div
              :class="item.likesStatus == 1 ? 'great1 point' : 'great point'"
              @click="greatHandle(item)"
            ></div>
          </div>
        </div>
        <EmptyList v-if="pageList.length == 0"></EmptyList>
      </div>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getHomeList"
      />
      <div class="mapsBox">
        <div style="width: 390px;height:470px;margin-right:30px">
          <Maps :mapdata="mapdata" :mapInfo="mapInfo"></Maps>
          <!-- <tlbs-map
            ref="mapRef"
            api-key="DN4BZ-TQJYZ-CB2XZ-73TN7-7AD2O-FSBG7"
            :center="center"
            :zoom="zoom"
            :control="control"
            style="height: 100%;"
          >
            <tlbs-multi-label
              ref="labelRef"
              :geometries="geometries"
              :styles="styles"
              :options="options"
            />
          </tlbs-map> -->
        </div>
        <div></div>
        <div class="mapTab">
          <div class="tabs">
            <div
              :class="tabIndex == index ? 'tabsItem tabsItem2' : 'tabsItem'"
              v-for="(item, index) in mapTabList"
              :key="'mapTabList_' + index"
              @click="changeTab(index)"
            >
              <div class="img"></div>
              <div class="mit">
                <div class="mit-t">{{ item.title }}</div>
                <div class="mit-c">
                  <div class="mit-cl">
                    <span style="color: #3f93f6">{{ item.num }}</span>家
                  </div>
                </div>
              </div>
            </div>
          </div>
          <bar2 :barData="barData"></bar2>
        </div>
      </div>
      <div class="expand-box" @click="expandClick"></div>
      <div class="large-box">
        <div class="large-title">浙江省商标代理机构</div>
      </div>
      <div class="brandBox" @click="goBrandPageOne">
        <!-- <div class="brand brand1" @click="goBrandPage('1')"></div>
        <div class="brand brand2" @click="goBrandPage('2')"></div> -->
      </div>
      <div class="large-box">
        <div class="large-title">知识产权服务平台</div>
      </div>
      <div class="leagueBox">
        <div class="league league1" @click="goLeaguePage('1')"></div>
        <div class="league league2" @click="goLeaguePage('2')"></div>
        <div class="league league3" @click="goLeaguePage('3')"></div>
      </div>
      <div class="center1" @click="goCenterPage"></div>
    </div>
    <Footer></Footer>
    <score :score_dialogVisible.sync="score_dialogVisible" :id="score_id"></score>
    <noemployDialog
      :noemploy_dialogVisible.sync="noemploy_dialogVisible"
      v-if="noemploy_dialogVisible"
    ></noemployDialog>
    <noemployDialog
      :noemploy_dialogVisible.sync="noemploy_dialogVisible"
      v-if="noemploy_dialogVisible"
    ></noemployDialog>
    <components
      :is="componentName"
      :league_dialogVisible.sync="league_dialogVisible"
      v-if="league_dialogVisible"
    ></components>
  </div>
</template>
<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import score from "@/views/components/score";
import bar1 from "@/views/components/bar1";
import bar2 from "@/views/components/bar2";
import Maps from "@/components/maps.vue";
import { Base64 } from "js-base64";
import {
  homeList,
  webIndex,
  indexNews,
  likesSave,
  likesUpdate,
  findDictItem,
  checkbranded,
  getCenterAddress,
} from "@/api/index.js";
// import AMapLoader from "@amap/amap-jsapi-loader";
import { mapGetters } from "vuex";
import noemployDialog from "./brand/noemployDialog.vue";
import league from "./league/league.vue";
import navigator from "./league/navigator.vue";
import industry from "./league/industry.vue";
export default {
  name: "index",
  metaInfo: {
    title: "“金种子”企业智能化管理系统（试运行）首页",
    meta: [
      {
        name: "keyWords",
        content: "知识产权"
      },
      {
        name: "description",
        content: "IPM金种子"
      }
    ]
  },
  components: {
    Header,
    Footer,
    bar2,
    score,
    noemployDialog,
    league,
    navigator,
    industry,
    Maps
  },
  data() {
    return {
      queryParams: {
        pageSize: 5,
        pageNum: 1,
        companyName: ""
      },
      rules: {},
      queryParams2: {
        pageSize: 5,
        pageNum: 1
      },
      total2: 0,
      total: 0,
      homeModuleList: [
        { title: "孵化级", type: "incubationApply", text: "登录后申报" },
        { title: "成长级", type: "growthApply", text: "登录后申报" },
        { title: "样板级", type: "sampleApply", text: "登录后申报" }
      ],
      homeBtnList: [
        { title: "孵化级" },
        { title: "成长级" },
        { title: "样板级" }
      ],
      newsBtnList: [
        { title: "金种子政策" },
        { title: "金种子活动" },
        { title: "试点方案" },
        { title: "经验交流" }
      ],
      homeBtnIndex: 0,
      newsBtnIndex: 0,
      pageList: [],
      mapTabList: [
        {
          title: "金种子",
          url: "jzz.png",
          url2: "11-1.png",
          num: 0,
          type: "jzz"
        },
        {
          title: "孵化级",
          url: "fhj.png",
          url2: "11-1.png",
          num: 0,
          type: "incubationArea"
        },
        {
          title: "成长级",
          url: "czj.png",
          url2: "12-1.png",
          num: 0,
          type: "growthArea"
        },
        {
          title: "样板级",
          url: "ybj.png",
          url2: "13-1.png",
          num: 0,
          type: "sampleArea"
        }
      ],
      barData: {
        dataX: [],
        dataY1: [],
        dataY2: [],
        dataY3: [],
        dataY: []
      },
      // map: null,
      // polygons: [],
      // markers: [], //记录所有文本点标记，用于删除
      // adcode: 330000,
      tabIndex: 0,
      indexData: {},
      mapList: [],
      areaData: [],
      arrayName: {
        0: "areaData",
        1: "incubationArea",
        2: "growthArea",
        3: "sampleArea"
      },
      newsList: [],
      operateUrl: "",
      cxglUrl: "",
      score_dialogVisible: false,
      score_id: "",
      // 腾讯地图
      // center: { lat: 29.7, lng: 120.412664 },
      // zoom: 7,
      // control: {
      //   scale: {},
      //   zoom: {
      //     position: "topRight"
      //   }
      // },
      // geometries: [
      //   {
      //     id: "杭州市",
      //     position: { lat: 30.274085, lng: 120.20507 },
      //     styleId: "style1",
      //     content: "0"
      //   },
      //   {
      //     id: "宁波市",
      //     position: { lat: 29.874556, lng: 121.63027 },
      //     styleId: "style1",
      //     content: "0"
      //   },
      //   {
      //     id: "温州市",
      //     position: { lat: 27.994267, lng: 120.69939 },
      //     styleId: "style1",
      //     content: "0"
      //   },
      //   {
      //     id: "绍兴市",
      //     position: { lat: 30.05033, lng: 120.5802 },
      //     styleId: "style1",
      //     content: "0"
      //   },
      //   {
      //     id: "嘉兴市",
      //     position: { lat: 30.753924, lng: 120.75854 },
      //     styleId: "style1",
      //     content: "0"
      //   },
      //   {
      //     id: "湖州市",
      //     position: { lat: 30.908446, lng: 120.094925 },
      //     styleId: "style1",
      //     content: "0"
      //   },
      //   {
      //     id: "金华市",
      //     position: { lat: 29.089042, lng: 119.647445 },
      //     styleId: "style1",
      //     content: "0"
      //   },
      //   {
      //     id: "衢州市",
      //     position: { lat: 28.981893, lng: 118.859457 },
      //     styleId: "style1",
      //     content: "0"
      //   },
      //   {
      //     id: "台州市",
      //     position: { lat: 28.672169, lng: 121.430241 },
      //     styleId: "style1",
      //     content: "0"
      //   },
      //   {
      //     id: "丽水市",
      //     position: { lat: 28.46763, lng: 119.922963 },
      //     styleId: "style1",
      //     content: "0"
      //   },
      //   {
      //     id: "舟山市",
      //     position: { lat: 29.990839, lng: 122.207215 },
      //     styleId: "style1",
      //     content: "0"
      //   }
      // ],
      // styles: {
      //   style1: {
      //     width: 10,
      //     height: 20,
      //     anchor: { x: 10, y: 20 },
      //     color: "#004ea5",
      //     size: 22,
      //     alignment: "center", // 文字水平对齐属性
      //     verticalAlignment: "middle" // 文字垂直对齐属性
      //   }
      // },
      // options: {
      //   collisionOptions: {
      //     sameSource: true // 是否开启图层内碰撞，优先级按rank进行碰撞
      //   }
      // },
      noemploy_dialogVisible: false,
      league_dialogVisible: false,
      componentName: "",
      //echarts地图
      mapdata: {
        height: "470px",
        IsClick: false,
      },
      mapInfo: [],
    };
  },
  created() {
    this.getHomeList();
    this.getList();
    this.getIndexData();
    findDictItem("JZZ_OPERATE_MANUAL").then(list => {
      //操作手册
      this.operateUrl = list.itemDesc;
    });
    findDictItem("JZZ_ZJS_CXGL").then(list => {
      //操作手册
      this.cxglUrl = list.itemDesc;
    });
  },
  mounted() {},
  computed: {
    ...mapGetters(["appUserType"]),
    isLogin() {
      return localStorage.getItem("access_token");
    }
  },
  methods: {
    getList() {
      indexNews({
        typeCode: "JZZ_NEWS_TYPE_" + (this.newsBtnIndex + 1),
        ...this.queryParams2
      }).then(res => {
        this.newsList = res.data.list;
        this.total2 = res.data.total;
      });
    },
    getIndexData() {
      webIndex().then(res => {
        this.indexData = res.data;
        this.mapTabList = [
          {
            title: "金种子",
            url: "jzz.png",
            url2: "11-1.png",
            num: this.indexData.applyCount || 0
          },
          {
            title: "孵化级",
            url: "11-2.png",
            url2: "11-1.png",
            num: this.indexData.incubationApplyCount || 0
          },
          {
            title: "成长级",
            url: "12-2.png",
            url2: "12-1.png",
            num: this.indexData.growthApplyCount || 0
          },
          {
            title: "样板级",
            url: "13-2.png",
            url2: "13-1.png",
            num: this.indexData.sampleApplyCount || 0
          }
        ];
        this.getApplyText();
        this.getEchartsData();
        this.initAMap();
      });
    },
    getApplyText() {
      if (!localStorage.getItem("access_token")) {
        return;
      }
      if (this.appUserType == "UTR_SINGER") {
        this.homeModuleList = [
          { title: "孵化级", type: "incubationApply", text: "" },
          { title: "成长级", type: "growthApply", text: "" },
          { title: "样板级", type: "sampleApply", text: "" }
        ];
        return;
      }
      //初始状态
      const nameMaps = ["incubationApply", "growthApply"];
      for (let i = 0; i < nameMaps.length; i++) {
        let NAME = nameMaps[i];
        if (!this.indexData[NAME].id && this.indexData[NAME].status != 1) {
          let o = this.homeModuleList.find(e => e.type == NAME);
          o.text = "立即申报";
        } else if (
          this.indexData[NAME].id &&
          this.indexData[NAME].status != 1
        ) {
          let o = this.homeModuleList.find(e => e.type == NAME);
          o.text = "继续申报";
        } else if (this.indexData[NAME].status == 1) {
          let o = this.homeModuleList.find(e => e.type == NAME);
          o.text = "查看申报";
          o.id = this.indexData[NAME].id;
        }
      }
      //将不符合的状态排除
      if (this.indexData.growthApply.status == 1) {
        //成长级已提交
        let o = this.homeModuleList.find(e => e.type == "incubationApply");
        if (["立即申报", "继续申报"].includes(o.text)) {
          //孵化级若为立即申报,继续申报，隐藏
          o.text = "";
        }
      }
      if (
        this.indexData.incubationApply.status == 1 &&
        this.indexData.incubationApply.applyStatus != 1
      ) {
        //孵化级已提交且未完成
        let o = this.homeModuleList.find(e => e.type == "growthApply");
        if (["立即申报", "继续申报"].includes(o.text)) {
          //成长级若为立即申报,继续申报，隐藏
          o.text = "";
        }
      }
      let o = this.homeModuleList.find(e => e.type == "sampleApply");
      o.text = "立即申报";
      // if (
      //   !this.indexData.incubationApply.id &&
      //   !this.indexData.growthApply.id
      // ) {
      //   this.homeModuleList = [
      //     { title: "孵化级", type: "incubationApply", text: "立即申报" },
      //     { title: "成长级", type: "growthApply", text: "立即申报" },
      //     { title: "样板级", type: "sampleApply", text: "立即申报" }
      //   ];
      // } else if (
      //   this.indexData.incubationApply.id &&
      //   this.indexData.incubationApply.status != 1
      // ) {
      //   this.homeModuleList = [
      //     { title: "孵化级", type: "incubationApply", text: "继续申报" },
      //     {
      //       title: "成长级",
      //       type: "growthApply",
      //       text:  "",
      //       id: this.indexData.growthApply.id
      //     },
      //     { title: "样板级", type: "sampleApply", text: "立即申报" }
      //   ];
      // } else if (
      //   this.indexData.growthApply.id &&
      //   this.indexData.growthApply.status != 1
      // ) {
      //   this.homeModuleList = [
      //     {
      //       title: "孵化级",
      //       type: "incubationApply",
      //       text: this.indexData.incubationApply.status == 1 ? "查看申报" : "",
      //       id: this.indexData.incubationApply.id
      //     },
      //     { title: "成长级", type: "growthApply", text: "继续申报" },
      //     { title: "样板级", type: "sampleApply", text: "立即申报" }
      //   ];
      // } else if (this.indexData.incubationApply.status == 1) {
      //   //孵化级完成，可以继续申报成长级
      //   console.log(this.indexData.incubationApply.applyStatus,this.indexData.growthApply.id)
      //   this.homeModuleList = [
      //     { title: "孵化级", type: "incubationApply", text: "查看申报",id:this.indexData.incubationApply.id },
      //     {
      //       title: "成长级",
      //       type: "growthApply",
      //       text:
      //         this.indexData.growthApply.status == 1
      //           ? "查看申报"
      //           : (this.indexData.incubationApply.applyStatus == 1 && !this.indexData.growthApply.id)//applyStatus是否可以申报
      //           ? "立即申报"
      //           : (this.indexData.growthApply.id)? "继续申报":"",
      //           id:this.indexData.growthApply.id
      //     },
      //     { title: "样板级", type: "sampleApply", text: "立即申报" }
      //   ];
      // } else if (this.indexData.growthApply.status == 1) {
      //   //成长级完成，不可继续申报孵化级
      //   this.homeModuleList = [
      //     { title: "孵化级", type: "incubationApply", text: "" },
      //     { title: "成长级", type: "growthApply", text: "查看申报",id:this.indexData.growthApply.id },
      //     { title: "样板级", type: "sampleApply", text: "立即申报" }
      //   ];
      // } else {
      //   this.$message.error(
      //     "错误!孵化级和成长级不可同时处在申报状态,请联系管理员!"
      //   );
      //   this.homeModuleList = [
      //     { title: "孵化级", type: "incubationApply" },
      //     { title: "成长级", type: "growthApply" },
      //     { title: "样板级", type: "sampleApply" }
      //   ];
      // }
      // const nameMaps = ["incubationApply", "growthApply", "sampleApply"];
      // for (let i = 0; i < nameMaps.length; i++) {
      //   let NAME = nameMaps[i];
      //   console.log("NAME", NAME);
      //   if (this.indexData[NAME].applyStatus == 0 && this.indexData[NAME].status != "1") {
      //     let o = this.homeModuleList.find(e => e.type == NAME);
      //     o.text = "";
      //   } else if (
      //     this.indexData[NAME].applyStatus == 1 &&
      //     !this.indexData[NAME].id
      //   ) {
      //     let o = this.homeModuleList.find(e => e.type == NAME);
      //     o.text = "立即申报";
      //   } else if (
      //     this.indexData[NAME].applyStatus == 1 &&
      //     this.indexData[NAME].status == "0" &&
      //     this.indexData[NAME].id
      //   ) {
      //     let o = this.homeModuleList.find(e => e.type == NAME);
      //     o.text = "继续申报";
      //   } else if (this.indexData[NAME].status == "1") {

      //     let o = this.homeModuleList.find(e => e.type == NAME);
      //     o.text = "查看申报";
      //     o.id = this.indexData[NAME].id
      //   }
      // }
      // console.log("after", this.homeModuleList);
    },
    greatHandle(item) {
      if (localStorage.getItem("access_token")) {
        if (item.likesId) {
          // 已经点赞过，调更新
          likesUpdate({
            applicationId: item.id,
            id: item.likesId,
            status: item.likesStatus ? 0 : 1
          }).then(res => {
            if (res.status == 200) {
              this.$message({
                message: item.likesStatus ? "已取消点赞" : "已点赞",
                type: "success"
              });
              this.getHomeList();
            }
          });
        } else {
          //初次点赞，调新增
          likesSave({ applicationId: item.id, status: 1 }).then(res => {
            if (res.status == 200) {
              this.$message({ message: "已点赞", type: "success" });
              this.getHomeList();
            }
          });
        }
      } else {
        this.$confirm("请先登录！", "提示", {
          confirmButtonText: "前往法人登录",
          cancelButtonText: "前往个人登录",
          distinguishCancelAndClose: true,
          type: "warning"
        })
          .then(() => {
            window.open(
              `${
                process.env.VUE_APP_DOMAINNAME
              }/cms/goDestAddress?url=${Base64.encode(
                window.location.href
              )}&mod=${encodeURI("金种子法人")}`
            );
          })
          .catch(action => {
            if (action === "cancel") {
              window.open(
                `${
                  process.env.VUE_APP_DOMAINNAME
                }/cms/goDestAddressPerson?url=${Base64.encode(
                  window.location.href
                )}&mod=${encodeURI("金种子个人")}`
              );
            }
          });
      }
    },
    getEchartsData() {
      this.barData = {
        dataX: [],
        dataY1: [],
        dataY2: [],
        dataY3: [],
        dataY: []
      };
      if (this.tabIndex == 0) {
        for (let i = 0; i < this.indexData.incubationArea.length; i++) {
          this.barData.dataX.push(this.indexData.incubationArea[i].areaName);
          this.barData.dataY1.push(this.indexData.incubationArea[i].count);
          this.barData.dataY2.push(this.indexData.growthArea[i].count);
          this.barData.dataY3.push(this.indexData.sampleArea[i].count);
          this.barData.dataY.push(this.indexData.areaData[i].count);
        }
      } else {
        // this.indexData[this.arrayName[this.tabIndex]].sort((a, b) => {
        //   return b.count - a.count;
        // });
        this.indexData[this.arrayName[this.tabIndex]].forEach(e => {
          this.barData.dataX.push(e.areaName);
          this.barData[`dataY${this.tabIndex}`].push(e.count);
        });
      }
    },
    changeTab(index) {
      if (this.tabIndex != index) {
        this.tabIndex = index;
        this.getEchartsData();
        // this.getInterfaceData();
        this.setTXMapData();
      }
    },
    // 跳转
    goTo(path) {
      window.open(path);
    },
    toFeedBack(id, objectionId) {
      if (localStorage.getItem("access_token")) {
        if (objectionId) {
          //存在objectionId，当前用户已经提交过异议，前往详情页
          this.$router.push(`/objectView?id=${objectionId}`);
        } else {
          //不存在objectionId，前往异议页提交
          this.$router.push(`/addFeedBack?id=${id}`);
        }
      } else {
        this.$confirm("请先登录！", "提示", {
          confirmButtonText: "前往法人登录",
          cancelButtonText: "前往个人登录",
          distinguishCancelAndClose: true,
          type: "warning"
        })
          .then(() => {
            window.open(
              `${
                process.env.VUE_APP_DOMAINNAME
              }/cms/goDestAddress?url=${Base64.encode(
                window.location.href
              )}&mod=${encodeURI("金种子法人")}`
            );
          })
          .catch(action => {
            if (action === "cancel") {
              window.open(
                `${
                  process.env.VUE_APP_DOMAINNAME
                }/cms/goDestAddressPerson?url=${Base64.encode(
                  window.location.href
                )}&mod=${encodeURI("金种子个人")}`
              );
            }
          });
      }
    },
    getHomeList() {
      homeList({
        type: this.homeBtnIndex + 1,
        ...this.queryParams
      }).then(res => {
        this.pageList = res.data.list;
        this.total = res.data.total;
      });
    },
    changenewsBtnIndex(index) {
      this.newsBtnIndex = index;
      this.queryParams.pageNum = 1;
      this.getList();
    },
    changehomeBtnIndex(index) {
      this.homeBtnIndex = index;
      this.queryParams.pageNum = 1;
      this.getHomeList();
    },
    initAMap() {
      this.setTXMapData();
    },
    setTXMapData() {//腾讯地图使用echarts取代
      this.mapInfo  = this.indexData[this.arrayName[this.tabIndex]];
    },
    getData(data, level) {
      var bounds = data.boundaries;
      if (bounds) {
        for (var i = 0, l = bounds.length; i < l; i++) {
          var polygon = new AMap.Polygon({
            map: this.map,
            strokeWeight: 1,
            strokeColor: "#0091ea",
            fillColor: "#80d8ff",
            fillOpacity: 0.2,
            path: bounds[i]
          });
          this.polygons.push(polygon);
        }
        this.map.setFitView(); //地图自适应
      }
    },
    getInterfaceData(adcode, mapList, level) {
      this.markers.length && this.map.remove(this.markers);
      this.areaData = this.indexData[this.arrayName[this.tabIndex]];
      this.mapList.forEach(e => {
        const o = this.areaData.find(i => i.areaCode == e.adcode);
        if (o) {
          o.position = [e.center.lng, e.center.lat];
        }
      });
      const commonStyle = {
        padding: ".25rem .25rem",
        "border-radius": ".25rem",
        "background-color": "transparent",
        "border-width": 0,
        "font-weight": "bold",
        "text-align": "center",
        "font-size": "16px",
        "line-height": "16px",
        color: "#004ea5"
      };
      this.areaData.forEach(e => {
        // console.log(e.areaName,e.areaCode,e.count,e.position)
        const mapSign = new AMap.Text({
          text: `<div><span style="font-size:20px;line-height:20px">${e.count}</span></br><span style="font-size:14px;line-height:14px">${e.areaName}</span></div>`,
          anchor: "center", // 设置文本标记锚点
          // draggable: true,
          cursor: "pointer",
          style: commonStyle,
          position: e.position
        });
        this.markers.push(mapSign);
        mapSign.setMap(this.map);
      });
    },
    goToApply(index, item) {
      const { text, id } = item;
      // console.log(item);
      if (text == "登录后申报") {
        this.$common.jzzlogin();
      } else {
        // if (index == 2) {
        //   //样板级暂不开放
        //   this.$message.error("暂不开放");
        //   return;
        // }
        if (this.appUserType == "UTR_SINGER") {
          this.$confirm("抱歉,当前账号为个人账号,无法进行申报", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {})
            .catch(() => {});
          return;
        } else {
          if (text == "立即申报" || text == "继续申报") {
            webIndex().then(res => {
              if (
                (index == 0 && res.data.growthApply.status == 1) ||
                (index == 0 && res.data.incubationApply.applyStatus == 1) ||
                (index == 1 &&
                  res.data.incubationApply.status == 1 &&
                  res.data.incubationApply.applyStatus != 1) ||
                (index == 1 && res.data.growthApply.applyStatus == 1)
              ) {
                this.$message.error(
                  "当前申报状态已变更，请刷新页面获取最新状态!"
                );
              } else {
                if (text == "立即申报") {
                  this.goTo(`/jzz/apply?level=${index + 1}`);
                } else {
                  this.goTo(`/jzz/apply?level=${index + 1}`);
                }
              }
            });
          } else if (text == "查看申报") {
            this.goTo(`/jzz/applyView?id=${id}`);
          }
        }
      }
    },
    companyinfoHandle(item) {
      if (localStorage.getItem("access_token")) {
        this.$router.push({ path: "/companyinfo", query: { id: item.id } });
      } else {
        this.$confirm("请先登录！", "提示", {
          confirmButtonText: "前往法人登录",
          cancelButtonText: "前往个人登录",
          distinguishCancelAndClose: true,
          type: "warning"
        })
          .then(() => {
            window.open(
              `${
                process.env.VUE_APP_DOMAINNAME
              }/cms/goDestAddress?url=${Base64.encode(
                window.location.href
              )}&mod=${encodeURI("金种子法人")}`
            );
          })
          .catch(action => {
            if (action === "cancel") {
              window.open(
                `${
                  process.env.VUE_APP_DOMAINNAME
                }/cms/goDestAddressPerson?url=${Base64.encode(
                  window.location.href
                )}&mod=${encodeURI("金种子个人")}`
              );
            }
          });
      }
    },
    operateDownload() {
      if (this.operateUrl) {
        window.open(this.operateUrl, "_blank");
      } else {
        this.$message.error("未获取到操作手册路径,请联系管理员!");
      }
    },
    openCXGL() {
      if (this.cxglUrl) {
        window.open(this.cxglUrl, "_blank");
      } else {
        this.$message.error("未获取到浙江省创新管理评价系统路径,请联系管理员!");
      }
    },
    clearForm() {
      this.$refs.queryParams.resetFields();
      this.queryParams.pageNum = 1;
      this.getHomeList();
    },
    goBrandPageOne(){
      window.open("https://toas.sbj.cnipa.gov.cn/toas-extra-prod/agencyInformationInquiry","_blank");
    },
    goBrandPage(type) {
      if (type == "1") {
        if (!this.isLogin) {
          this.$confirm("请先登录！", "提示", {
            confirmButtonText: "前往法人登录",
            cancelButtonText: "前往个人登录",
            distinguishCancelAndClose: true,
            type: "warning"
          })
            .then(() => {
              window.open(
                `${
                  process.env.VUE_APP_DOMAINNAME
                }/cms/goDestAddress?url=${Base64.encode(
                  window.location.href
                )}&mod=${encodeURI("金种子法人")}`
              );
            })
            .catch(action => {
              if (action === "cancel") {
                window.open(
                  `${
                    process.env.VUE_APP_DOMAINNAME
                  }/cms/goDestAddressPerson?url=${Base64.encode(
                    window.location.href
                  )}&mod=${encodeURI("金种子个人")}`
                );
              }
            });
        } else {
          checkbranded().then(res => {
            if (res.data) {
              this.$router.push("/agentorg");
            } else {
              this.$message.error("“金种子”在库企业专属功能，请先入库。");
            }
          });
        }
      } else {
        this.noemploy_dialogVisible = true;
      }
    },
    goLeaguePage(type) {
        if (!this.isLogin) {
          this.$confirm("请先登录！", "提示", {
            confirmButtonText: "前往法人登录",
            cancelButtonText: "前往个人登录",
            distinguishCancelAndClose: true,
            type: "warning"
          })
            .then(() => {
              window.open(
                `${
                  process.env.VUE_APP_DOMAINNAME
                }/cms/goDestAddress?url=${Base64.encode(
                  window.location.href
                )}&mod=${encodeURI("金种子法人")}`
              );
            })
            .catch(action => {
              if (action === "cancel") {
                window.open(
                  `${
                    process.env.VUE_APP_DOMAINNAME
                  }/cms/goDestAddressPerson?url=${Base64.encode(
                    window.location.href
                  )}&mod=${encodeURI("金种子个人")}`
                );
              }
            });
        } else {
          checkbranded().then(res => {
            if (res.data) {
              this.openLeague(type);
            } else {
              this.$message.error("“金种子”在库企业专属功能，请先入库。");
            }
          });
        }

    },
    openLeague(type){

      if (type == "1") {
        this.componentName = "league";
      } else if (type == "2") {
        this.componentName = "navigator";
      } else if (type == "3") {
        this.componentName = "industry";
      }
      this.league_dialogVisible = true;
    },
    expandClick() {
      window.open(
        "https://ggfw.cnipa.gov.cn/poam/txnqueryAgencyOrg.do",
        "_blank"
      );
    },
    goCenterPage() {
      getCenterAddress().then(res=>{
        window.open(res.itemDesc,"_blank");
      })
    }
  }
};
</script>
<style scoped lang="less">
.app-background {
  background-color: #f4f6fa;
  min-width: 1200px;
}

#banner-wrap {
  width: 100%;
  // max-width: 1200px;
  height: 520px;
  // background-color: blue;

  background-size: 100% 100%;
}
.homeTop {
  margin-top: -38px;
}

.homeModule {
  width: 100%;
  height: 140px;
  display: flex;
  justify-content: space-between;
  position: relative;
}

.homeModuleItem {
  width: 368px;
  height: 100%;
  background-color: #fff;
  box-sizing: border-box;
  padding: 38px 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
  background-image: url("../assets/1.png");
  background-size: 100% 100%;
}
.homeModuleItem:nth-child(2) {
  background-image: url("../assets/2.png");
  background-size: 100% 100%;
}
.homeModuleItem:nth-child(3) {
  background-image: url("../assets/3.png");
  background-size: 100% 100%;
}
.homeModuleItem .mit {
  flex: 1;
  margin-left: 90px;
}

.homeModuleItem .mit .mit-t {
  font-weight: 700;
  font-size: 20px;
  line-height: 20px;
}

.homeModuleItem .mit .mit-c {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  font-size: 15px;
  color: #aaa;
}
.homeModuleItem .mit .mit-cl {
  display: flex;
  align-items: center;
}
.homeModuleItem .mit .mit-cl:hover {
  color: #409eff;
}
.homeModuleItem .mit .mit-cl:hover::after {
  content: "";
  display: inline-block;
  width: 16px;
  height: 17px;
  margin-left: 4px;
  background-image: url("../assets/4.png");
  background-size: 100% 100%;
}
.homeModuleItem .mit-cl::after {
  content: "";
  display: inline-block;
  width: 16px;
  height: 17px;
  margin-left: 4px;
  background-image: url("../assets/5.png");
  background-size: 100% 100%;
}
.homeModuleItem .mit .mit-cr {
  display: flex;
  align-items: center;
}
.homeModuleItem .mit-cr::after {
  content: "";
  display: inline-block;
  width: 16px;
  height: 17px;
  margin-left: 4px;
  background-image: url("../assets/5.png");
  background-size: 100% 100%;
}

.homeModuleItem .mit .mit-cr:hover {
  color: #409eff;
}
.homeModuleItem .mit .mit-cr:hover::after {
  content: "";
  display: inline-block;
  width: 16px;
  height: 17px;
  margin-left: 4px;
  background-image: url("../assets/4.png");
  background-size: 100% 100%;
}
.midbtn {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  position: relative;
}
.operatebook {
  display: block;
  position: absolute;
  width: 200px;
  height: 110px;
  // right: 0;
  left: calc(990px + (100vw - 1200px) / 2);
  // left: calc( 400px + 50vw );
  top: -22px;
  border-radius: 10px;
  background: url(../assets/operate.png);
  background-size: 100% 100%;
}
.midbtn > div {
  padding: 5px 30px;
  box-sizing: border-box;
  border: 1px solid #3f93f6;
  background-color: #fff;
  color: #3f93f6;
  border-radius: 16.5px;
  cursor: pointer;
}

.midbtn > div:nth-child(n + 2) {
  margin-left: 40px;
}

.midbtn > div.active {
  background-color: #3f93f6;
  color: #fff;
  border-radius: 16.5px;
  cursor: pointer;
}

.pageList {
  width: 100%;
  border-radius: 10px;
  padding: 0 30px;
  margin-top: 30px;
  background-color: #fff;
  margin-bottom: 30px;
}

.pageItem {
  width: 100%;
  display: flex;
  align-items: center;
  height: 64px;
  box-sizing: border-box;
  line-height: 64px;
  border-bottom: 1px solid #f2f2f2;
}

.pageItem:nth-child(5) {
  border: none;
}

.pageItem img {
  width: 10px;
  height: 10px;
  margin-right: 16px;
}
.pageItem span {
  width: 180px;
  color: #aaa;
}
.pageItem2 span {
  width: 90px;
  color: #aaa;
}

.pageItem .pageItemTitle {
  width: 700px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-right: 40px;
}
.pageItem .pageItemTitle .name {
  max-width: 700px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.pageItem .pageItemTitle .name:hover {
  color: #409eff;
}
.pageItem .pageItemTitle i {
  display: inline-block;
  width: 110px;
  height: 20px;
  background: url(~@/assets/settle.png);
  background-size: 100% 100%;
  margin-left: 10px;
}
.pageItemBtnBox {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
.pageItem .pageItemBtn {
  float: left;
  // width: 60px;
  padding: 0 9px;
  height: 25px;
  font-size: 13px;
  background-color: #409eff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
}
.pageItemBtn:hover {
  background-color: #7ab7f5;
}
.pageItemBtnBox .great {
  float: right;
  width: 25px;
  height: 25px;
  background: url(~@/assets/great.png);
  background-size: 100% 100%;
}
.pageItemBtnBox .great1 {
  float: right;
  width: 25px;
  height: 25px;
  background: url(~@/assets/great1.png);
  background-size: 100% 100%;
}
.mapsBox {
  width: 100%;
  height: 530px;
  box-sizing: border-box;
  padding: 30px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.mapTab {
  flex: 1;
}
.mapTab .tabs {
  height: 80px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}
#echartsDom {
  width: 100%;
  height: 380px;
}
.tabs {
  width: 720px;
  height: 140px;
}

.tabsItem {
  width: 170px;
  height: 100%;
  box-sizing: border-box;
  padding: 10px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 17px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
  cursor: pointer;
}
.tabsItem:nth-child(1) {
  background: url("~@/assets/jzz.png");
  background-size: 100% 100%;
}
.tabsItem:nth-child(2) {
  background: url("~@/assets/fhj.png");
  background-size: 100% 100%;
}
.tabsItem:nth-child(3) {
  background: url("~@/assets/czj.png");
  background-size: 100% 100%;
}
.tabsItem:nth-child(4) {
  background: url("~@/assets/ybj.png");
  background-size: 100% 100%;
}
.tabsItem2 {
  box-shadow: 0px 0px 6px 6px rgba(0, 234, 255, 0.6);
}

.tabsItem .img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

.tabsItem .mit {
  flex: 1;
}

.homeModuleItem .mit .mit-t {
  font-weight: 500;
  font-size: 20px;
  line-height: 16px;
}

.tabsItem .mit .mit-c {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 16px;
}
.tabsItem .mit .mit-c span {
  font-size: 18px;
  font-weight: 700;
}
#mapContainer {
  height: 470px;
  width: 100%;
  margin-right: 30px;
}
.banner {
  width: 100%;
  height: 350px;
  // background-color: rgb(131, 195, 220);
  background-image: url("../assets/beijin.png");
  background-size: 100% 100%;
}
.large-box {
  display: flex;
  justify-content: center;
  margin: 30px 0;
  position: relative;

  .large-title {
    font-weight: 700;
    font-size: 20px;
    position: relative;
  }

  .large-title::before {
    width: 18px;
    height: 18px;
    position: absolute;
    content: "";
    top: 4px;
    left: -38px;
    background: url(~@/assets/tl.png);
    background-size: 100% 100%;
  }

  .large-title::after {
    width: 18px;
    height: 18px;
    position: absolute;
    content: "";
    top: 4px;
    right: -38px;
    background: url(~@/assets/tr.png);
    background-size: 100% 100%;
  }

  .large-more {
    position: absolute;
    right: 10px;
    line-height: 26px;
    color: #409eff;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    .img {
      background: url(~@/assets/more.png);
      background-size: 100% 100%;
      width: 16px;
      height: 16px;
      display: inline-block;
      margin-left: 5px;
    }
  }
}
/* 去除高德地图水印 */
.amap-logo {
  display: none !important;
}
.amap-copyright {
  display: none !important;
}
.point {
  cursor: pointer;
}
.cxgl {
  position: fixed;
  right: 0;
  top: calc(50% - 120px);
  width: 200px;
  height: 110px;
  background: url(../assets/cxgl.png);
  background-size: 100% 100%;
  cursor: pointer;
  z-index: 2025;
}
.zmba {
  position: fixed;
  right: 0;
  top: calc(50% - 0px);
  width: 200px;
  height: 110px;
  background: url(../assets/专密备案认定平台.png);
  background-size: 100% 100%;
  cursor: pointer;
  z-index: 2025;
}
.zmcp {
  position: fixed;
  right: 0;
  top: calc(50% + 120px);
  width: 200px;
  height: 110px;
  background: url(../assets/专密产品推广平台.png);
  background-size: 100% 100%;
  cursor: pointer;
  z-index: 2025;
}
.emptys {
  background: #fff;
  padding: 10px 0;
  text-align: center;
  color: #f60;
  font-size: 20px;
}
.brandBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;
  margin-bottom: 20px;
  background: url(../assets/信息公示查询.png);
  background-size: 100% 100%;
  cursor: pointer;
  // .brand {
  //   height: 100%;
  //   width: 585px;
  //   cursor: pointer;
  // }
  // .brand1 {
  //   background: url(../assets/brand1.png) no-repeat 0px 0px;
  //   background-size: 100% 100%;
  // }
  // .brand2 {
  //   background: url(../assets/brand2.png) no-repeat 0px 0px;
  //   background-size: 100% 100%;
  // }
}
.leagueBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 160px;
  margin-bottom: 20px;
  .league {
    height: 100%;
    width: 32%;
    cursor: pointer;
  }
  .league1 {
    background: url(../assets/league1.png) no-repeat 0px 0px;
    background-size: 100% 100%;
  }
  .league2 {
    background: url(../assets/league2.png) no-repeat 0px 0px;
    background-size: 100% 100%;
  }
  .league3 {
    background: url(../assets/league3.png) no-repeat 0px 0px;
    background-size: 100% 100%;
  }
}
.expand-box {
  width: 100%;
  height: 100px;
  background: url(../assets/expand.png) no-repeat 0px 0px;
  background-size: 100% 100%;
  cursor: pointer;
}
.center1 {
  width: 100%;
  height: 160px;
  background: url(../assets/center1.png) no-repeat 0px 0px;
  background-size: 100% 100%;
  cursor: pointer;
  margin-bottom: 20px;
}
</style>